import React from "react";
import PrevArrow from "~/components/slickSlider/PrevArrow";
import NextArrow from "~/components/slickSlider/NextArrow";
import CountdownTimer from "~/components/countdownTime/CountdownTime";
import Slider from "react-slick";
import Item from "~/components/miniComponent/item/Item";
import "./FlashSales.scss";
import { Link, useNavigate } from "react-router-dom";

function FlashSales({ listProducts }) {
  const navigate = useNavigate();
  // CountdownTimer
  const targetDate = new Date("2023-12-31T23:59:59");

  // Slick Slider
  var FlashSalesSlider = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: Math.min(Math.max(listProducts?.length, 1), 4),
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(Math.max(listProducts?.length, 1), 3),
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: Math.min(Math.max(listProducts?.length, 1), 2),
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: Math.min(Math.max(listProducts?.length, 1), 2),
          slidesToScroll: 1,
        },
      },
    ],
  };
  const handleShowAll = () => {
    navigate("/flash-sale");
  };
  return (
    <div className="my-5">
      <div className="sub-title-heading">Hôm nay</div>
      <div className="heading">
        <h3 className="title-heading">
          <Link to="/flash-sale">Đang giảm giá</Link>
        </h3>
        <div className="countdown-timer">
          <CountdownTimer targetDate={targetDate} />
        </div>
      </div>
      <Slider className="list_items" {...FlashSalesSlider}>
        {listProducts?.map((item) => {
          return <Item product={item} key={item._id} />;
        })}
      </Slider>
      <button className="cus-btn button-container btn-all-products" onClick={handleShowAll}>
        Xem tất cả
      </button>
    </div>
  );
}

export default FlashSales;
